<template>
  <component
    :is="way"
    v-bind="{ ...$props, ...$attrs }"
    :loading="loading"
    :error="error"
    :response="response"
    :responses="responses"
    :comments="comments"
    :history="history"
    :voicebot="voicebot"
    :fetch="fetch"
    :set-stars="setStars"
    v-on="$listeners"
  />
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import DefaultScene from './SceneContent.vue';
import PROCESS_NAMES from '@/process/names';

const SportmasterScene = () =>
  import(/* webpackChunkName: "sportmaster-response-scene" */ '@/process/sportmaster/components/response/Scene');
const BatChampionshipScene = () =>
  import(
    /* webpackChunkName: "bat-championship-response-scene" */ '@/process/bat-championship/components/response/SceneProcess.vue'
  );
const BatPersonalAccountScene = () =>
  import(
    /* webpackChunkName: "bat-personal-account-response-scene" */ '@/process/bat-personal-account/components/response/SceneProcess.vue'
  );
const CitibankScene = () =>
  import(/* webpackChunkName: "citibank-response-scene" */ '@/process/citibank/components/response/SceneProcess.vue');

export default {
  name: 'ResponseSceneWrapper',

  components: {
    DefaultScene,
    SportmasterScene,
    BatChampionshipScene,
    BatPersonalAccountScene,
    CitibankScene
  },

  props: {
    responseId: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    ...mapState('vacancies', ['vacancies_list']),

    ...mapState('responses', ['error']),

    ...mapGetters({ response: 'response/one' }),

    ...mapGetters('response', ['loading', 'comments', 'history', 'voicebot']),

    starRating() {
      return this.response.star ? this.response.star.value : null;
    },

    responseIdParam() {
      return this.$route.params ? this.$route.params.id : null;
    },

    responses() {
      const activeVacancies = this.vacancies_list.filter(vacancy => vacancy.is_active);

      const isResponseFromActiveVacancy = response =>
        activeVacancies.some(vacancy => vacancy.id === response.vacancy.id);

      return this.$store.getters['responses/list'].filter(response => isResponseFromActiveVacancy(response));
    },

    way() {
      if (
        this.getProcessName === PROCESS_NAMES.SPORTMASTER ||
        this.getProcessName === PROCESS_NAMES.BAT_CHAMPIONSHIP ||
        this.getProcessName === PROCESS_NAMES.BAT_PERSONAL_ACCOUNT ||
        this.getProcessName === PROCESS_NAMES.CITIBANK
      ) {
        return `${this.getProcessName}-scene`;
      } else {
        return 'default-scene';
      }
    }
  },

  watch: {
    responseIdParam() {
      this.fetch();
    },

    response(oldVal) {
      if (oldVal.id) {
        let title = this.$tr('pageTitles.prefix');
        if (oldVal.candidate) {
          title = `${oldVal.candidate.name + ' ' + oldVal.candidate.surname} - ${title}`;
          document.title = title;
        }
      }
    }
  },

  beforeMount() {
    if (this.$route.query && this.$route.query.vacancyId) {
      this.$store.commit('responses/updateFilters', {
        data: {
          vacancy: {
            id: this.$route.query.vacancyId
          }
        }
      });
    }

    this.CHANGE_PAGINATION_COUNT(20);
  },

  async created() {
    await this.fetch();
  },

  beforeDestroy() {
    this.$store.commit('vacancy/videointerview/setIndex', 0);
  },

  methods: {
    ...mapMutations('vacancies', ['CHANGE_PAGINATION_COUNT']),

    ...mapActions('vacancies', ['fetchVacanciesList']),

    async fetch() {
      if (this.$route.params.id !== undefined) {
        await this.$store.dispatch('response/fetch', { id: this.$route.params.id });
      }

      this.$store.dispatch('responses/fetch').then(async () => {
        await this.fetchVacanciesList();
        this.$store.dispatch('dictionary/fetchStagesAndStatuses');
      });
    },

    setStars(count) {
      if (count !== this.starRating) {
        this.$store
          .dispatch('response/setStar', {
            model: this.response,
            count
          })
          .then(() => {
            if (window.gtag) {
              window.gtag({ event: 'response_star' });
            }
          });
      } else {
        this.$store.dispatch('response/delete_star', {
          model: this.response
        });
      }
    }
  }
};
</script>
